/*
 *  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  * No part of this publication may be reproduced, distributed,
 *  * or transmitted in any form or by any means, including photocopying, recording,
 *  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  * except in the case of brief quotations embodied in critical
 *  * reviews and certain other noncommercial uses permitted by copyright law.
 *  *  author : BS
 *  *  date : 1/18/23, 6:26 PM
 */

import { DataTab } from '../../model/tabs/data-tab';
import { Entity } from '../../model/entity/entity';

export class DataTabBuilder<T extends Entity> {
  private readonly _dataTab: DataTab<T>;

  constructor(data: T) {
    this._dataTab = new DataTab<T>(
      data.getId(),
      data.getLabel(),
      data.getId(),
      data,
    );
    return this;
  }

  public setId(id: string): DataTabBuilder<T> {
    this._dataTab.id = id;
    return this;
  }

  public setLabel(label: string): DataTabBuilder<T> {
    this._dataTab.label = label;
    return this;
  }

  public setContentId(contentId: string): DataTabBuilder<T> {
    this._dataTab.contentId = contentId;
    return this;
  }

  public setIcon(icon: string): DataTabBuilder<T> {
    this._dataTab.icon = icon;
    return this;
  }

  public setIsOpen(isOpen): DataTabBuilder<T> {
    this._dataTab.isOpen = isOpen;
    return this;
  }

  public setConfirmBeforeClose(confirmBeforeClose): DataTabBuilder<T> {
    this._dataTab.confirmBeforeClose = confirmBeforeClose;
    return this;
  }

  public setCanClose(canClose: boolean): DataTabBuilder<T> {
    this._dataTab.canClose = canClose;
    return this;
  }

  public setColor(color: string): DataTabBuilder<T> {
    this._dataTab.color = color;
    return this;
  }

  public setEnable(enable: boolean): DataTabBuilder<T> {
    this._dataTab.enable = enable;
    return this;
  }

  public build(): DataTab<T> {
    return this._dataTab;
  }
}
